
    <div
      class="row"
    >
      <formly-field *ngFor="let f of field.fieldGroup" [field]="f"  class="col-md-6">
      </formly-field>
    </div>
  